'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTrainingsByRoles = exports.deleteTrainingResource = exports.updateTrainingResource = exports.createTrainingResource = exports.getAllTrainingResources = exports.getTrainingResource = undefined;

var _middleware = require('../../middleware');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

var getTrainingResource = exports.getTrainingResource = function getTrainingResource(identifier) {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({}, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/trainings/name/' + identifier
      },
      types: ['GET_TRAINING_START', 'GET_TRAINING', 'GET_TRAINING_ERROR']
    }));
  };
};

var getAllTrainingResources = exports.getAllTrainingResources = function getAllTrainingResources() {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({}, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/trainings/all'
      },
      types: ['GET_TRAININGS_START', 'GET_TRAININGS', 'GET_TRAININGS_ERROR']
    }));
  };
};

var createTrainingResource = exports.createTrainingResource = function createTrainingResource(data) {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({}, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/trainings',
        method: 'POST',
        data: data
      },
      types: ['CREATE_TRAINING_START', 'CREATE_TRAINING', 'CREATE_TRAINING_ERROR']
    }));
  };
};

var updateTrainingResource = exports.updateTrainingResource = function updateTrainingResource(data) {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({}, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/trainings/' + data.id,
        method: 'PUT',
        data: data
      },
      types: ['UPDATE_TRAINING_START', 'UPDATE_TRAINING', 'UPDATE_TRAINING_ERROR']
    }));
  };
};

var deleteTrainingResource = exports.deleteTrainingResource = function deleteTrainingResource(id) {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({}, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/trainings/' + id,
        method: 'DELETE'
      },
      types: ['DELETE_TRAINING_START', 'DELETE_TRAINING', 'DELETE_TRAINING_ERROR']
    }));
  };
};

var getTrainingsByRoles = exports.getTrainingsByRoles = function getTrainingsByRoles() {
  var roles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return function (dispatch, getState) {
    roles = roles.filter(function (r) {
      return r !== undefined;
    });
    return dispatch(_defineProperty({}, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/trainings/roles',
        method: 'POST',
        data: roles
      },
      types: ['GET_TRAINING_ROLES_START', 'GET_TRAINING_ROLES', 'GET_TRAINING_ROLES_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/trainings/index.js
// module id = 249
// module chunks = 0